var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktopUp)?_c('ETourActivityAds',_vm._g(_vm._b({attrs:{"page-position":"sidebar"}},'ETourActivityAds',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }